import { Menu, LogOut } from 'lucide-react'
import { useAuthStore } from '../stores/auth'
import { api } from '../lib/api'

export function Header({ onMenuClick }: { onMenuClick: () => void }) {
  const user = useAuthStore((s) => s.user)

  async function logout() {
    try {
      await api.post('/auth/logout')
    } catch {
      /* ignore */
    }
    useAuthStore.getState().clear()
    window.location.href = '/login'
  }

  return (
    <header className="flex h-14 items-center justify-between border-b border-b4l-border bg-white px-4">
      <button className="md:hidden" onClick={onMenuClick} aria-label="Deschide meniul">
        <Menu size={20} />
      </button>
      <div className="flex-1" />
      <div className="flex items-center gap-3">
        <span className="text-[13px] text-b4l-text-muted">{user?.name ?? user?.email}</span>
        <button
          onClick={logout}
          className="flex items-center gap-1.5 rounded-md px-2.5 py-1.5 text-[13px] text-b4l-text-muted hover:bg-b4l-bg-soft"
        >
          <LogOut size={15} />
          Ieșire
        </button>
      </div>
    </header>
  )
}
